<template>
  <div>
    <navigation-component></navigation-component>
    <header-component></header-component>
    <services-component></services-component>
    <portfolio-component></portfolio-component>
    <about-component></about-component>
    <clients-component></clients-component>
    <contact-component></contact-component>
    <footer-component></footer-component>
  </div>
</template>

<script>
import NavigationComponent from "./components/NavigationComponent/navigationComponent";
import HeaderComponent from "./components/headerComponent/headerComponent";
import ServicesComponent from "./components/ServicesComponent/servicesComponent";
import PortfolioComponent from "./components/PortfolioComponent/portfolioComponent";
import AboutComponent from "./components/AboutComponent/aboutComponent";
import ClientsComponent from "./components/ClientsComponent/clientsComponent";
import ContactComponent from "./components/ContactComponent/contactComponent";
import FooterComponent from './components/FooterComponent/footerComponent';

export default {
  name: "app",
  components: {
    NavigationComponent,
    HeaderComponent,
    ServicesComponent,
    PortfolioComponent,
    AboutComponent,
    ClientsComponent,
    ContactComponent,
    FooterComponent
  },
  data() {
    return {
    };
  },
  created() {
  },
  methods: {
  }
};
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/App.vue